import React from 'react';
import { Link } from 'react-router-dom';
import { history }  from '../../routers/AppRouter'
import getAppConfig  from '../../config/AppConfig';
 
class Footer extends React.Component {


    onClickSignUpButton = () => {
        console.log("Onclick sign up button pressed")
        history.push("/signup");
    }

    render(){

        let siteUrl = getAppConfig("siteUrl");
        let blogUrl = getAppConfig("blogUrl");

        return (
            <footer className="repair-footer-area">
                
                <section className="repair-subscribe-area">
                    <div className="container">
                        <div className="repair-subscribe-content">
                            <h2>Set up an Event in Minutes using Simple Stepwise Process</h2>

                            <form className="newsletter-form" data-toggle="validator">
                            {/*
                                <div className="form-group">
                                    <input type="text" className="input-newsletter" placeholder="First Name" />
                                </div>

                                <div className="form-group">
                                    <input type="text" className="input-newsletter" placeholder="Last Name" />
                                </div>

                                <div className="form-group">
                                    <input 
                                        type="email" 
                                        className="input-newsletter" 
                                        placeholder="Email Address*" 
                                        name="EMAIL" 
                                        required ={true} 
                                        autoComplete="off" 
                                    />
                                </div>
                          */}
                        <div className="rc-flex-container-center">
                        {/* <button type="submit" className="btn btn-primary">Sign Up Free<i className="icofont-arrow-right"></i></button> */}
                        
                        <Link to="/signup" 
                                className={`
                                btn btn-primary-orange ${true ? "animated fadeInDown" : ''}
                            `}
                        >Sign Up Free</Link>
                        </div>    
                            <div id="validator-newsletter" className="form-result"></div>
                            </form>
                        </div>
                    </div>
                </section>

                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="single-footer-widget">
                                <div className="logo">
                                     {/* <Link to="repair-index.html">Axo<span>lot</span></Link> */ }
                                    <Link to="/" style={{textDecoration: 'none'}}>
                                    <p className="page-header__title">Pitch In <span className="page-header__title-part2">Club</span> </p>
                                    </Link>
                                </div>
                                <p>The Simple Event Planning / Tracking Tool that helps with Organizing events and Encourages people to Pitch In</p>
                                <ul className="social-links">
                                    <li><a href="https://www.facebook.com/pitchinclub"><i className="icofont-facebook"></i></a></li>
                                    <li><a href="https://www.linkedin.com/company/pitch-in-club"><i className="icofont-linkedin"></i></a></li>
                                    <li><a href="https://twitter.com/pitchinclub"><i className="icofont-twitter"></i></a></li>
                                    {/*  <li><Link to="#"><i className="icofont-instagram"></i></Link></li> */}
                                    
                                </ul>
                            </div>
                        </div>
                        
                        <div className="col-lg-3 col-md-6">
                            <div className="single-footer-widget">
                                <h3>Resources</h3>
                                {/*
                                <ul className="services-list">
                                    <li><Link to="/resources/features">Features</Link></li>
                                    <li><Link to="/resources/type-of-events">Type of Events</Link></li>
                                    <li><Link to="/resources/helping-hands">Helping Hands List</Link></li>
                                    <li><Link to="/resources/contribution-list">Contribution List</Link></li>
                                </ul>
                                */}
                                <ul className="services-list">
                                    <li><a href={`${siteUrl}/resources/features`}>Features</a></li>
                                    <li><a href={`${siteUrl}/resources/type-of-events`}>Type of Events</a></li>
                                    <li><a href={`${siteUrl}/resources/helping-hands`}>Helping Hands List</a></li>
                                    <li><a href={`${siteUrl}/resources/contribution-list`}>Contribution List</a></li>
                                    <li><a href={`${siteUrl}/resources/faq`}>FAQ</a></li>
                                    <li><Link to="#"></Link></li>
                                </ul>
                                
                            </div>
                        </div>

                    
                        <div className="col-lg-3 col-md-6">
                        <div className="single-footer-widget">
                            <h3>&nbsp;&nbsp;________________</h3>
                          {/*
                            <ul className="services-list">
                                <li><Link to="/faq">FAQ</Link></li>
                                <li><Link to="/resources/how-to-create-event">How To Create Event</Link></li>
                                <li><Link to="/resources/how-to-pitch-in">How To Pitch In</Link></li>
                                <li><Link to="/about-us">About Us</Link></li>
                            </ul>
                          */}
                            
                            <ul className="services-list">
                                <li><a href={`${siteUrl}/resources/how-to-create-event`}>How To Create Event</a></li>
                                <li><a href={`${siteUrl}/resources/how-to-pitch-in`}>How To Pitch In</a></li>
                                <li><a href={`${siteUrl}/resources/event-planning-tools`}>Event Planning Tools</a></li>
                                <li><a href={`${siteUrl}/resources/about-us`}>About Us</a></li>
                            </ul>
                            
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="single-footer-widget">
                            <h3>Contact</h3>

                            <ul className="contact-list">
                                <li><span style={{fontWeight: '400'}}>Drop us a note below</span> </li>
                                
                                <li><span></span> <Link to="/contact-form">Contact Form</Link></li>
                            {/*
                                <li><span>Email:</span> <Link to="/contact-form">Contact Form</Link></li>
                                <li><span>Phone:</span> <Link to="#">+0 (321) 984 754</Link></li>
                                <li><span>Fax:</span> <Link to="#">+0 (321) 984 754</Link></li>
                            */}
                            </ul>
                        </div>
                    </div>



                    </div>
                </div>
                
                <div className="repair-copyright-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <p>{`Copyright @${new Date().getFullYear()} Pitch In Club. All rights reserved.`}</p>
                            </div>
                            <div className="col-lg-6 col-md-6 text-right">
                                <ul>
                                    {/* <li><Link to="#">Terms & Conditions</Link></li> */}
                                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="map-box">
                    <img src={require("../../assets/img/footer-map.png")} alt="footer image" />
                </div>
            </footer>
        );
    }
}
 
export default Footer;

// ===========================================================================
// Other components of Footer section  that a kept below for resuse as needed.
// ===========================================================================
// <div className="col-lg-3 col-md-6">
// <div className="single-footer-widget">
//     <h3>Contact</h3>

//     <ul className="contact-list">
//         <li><span></span>To drop us a note, </li>
//         <li><span></span> click below.</li>
//         <li><span></span> <Link to="/contact-form">Contact Form</Link></li>
//     {/*
//         <li><span>Email:</span> <Link to="/contact-form">Contact Form</Link></li>
//         <li><span>Phone:</span> <Link to="#">+0 (321) 984 754</Link></li>
//         <li><span>Fax:</span> <Link to="#">+0 (321) 984 754</Link></li>
//     */}
//     </ul>
// </div>
// </div>

// <div className="col-lg-3 col-md-6">
// <div className="single-footer-widget">
//     <h3>Maintenance Hours</h3>

//     <ul className="working-hours">
//         <li><span></span>This timeframe is reserved for site maintenance</li>
//    {/*     <li><span>Tuesday:</span> 8AM - 6PM</li>
//         <li><span>Wednesday:</span> 8AM - 6PM</li>
//         <li><span>Thursday - Friday:</span> 8AM - 6PM</li>
//    */}
//         <li><span>Sunday:</span>&nbsp; 8PM - 11PM EST</li>
//     </ul>
// </div>
// </div>


// WEBPACK FOOTER //
// ./src/components/versionSeven/Footer.js